import type { Components, Theme } from '@mui/material/styles';
import { typography } from '../tokens/typography';

export const MuiLink: Components<Theme>['MuiLink'] = {
  styleOverrides: {
    root: ({ theme: { palette } }) => ({
      ...typography.body1,
      color: palette.info.main,
      textDecorationColor: palette.info.main,
      cursor: 'pointer',
    }),
  },
};
